import React from 'react';
import PropTypes from 'prop-types';

import PageHead from 'bdvp-common/src/components/Head';
import {
    useLang,
    useDictionary,
    useMediaConfigGame,
} from 'bdvp-common/src/hooks/config';
import { DateUtils, getVideoObjectSchema } from 'bdvp-common/src/utils';

const Head = (props) => {

    const {
        data,
        mediaItem,
        loading,
    } = props;

    const lang = useLang();
    const dictionary = useDictionary();
    const config = useMediaConfigGame();

    const awayTeam = data.away?.shortName;
    const homeTeam = data.home?.shortName;
    const gameDate = data.gameDate;
    const shortGameDate = gameDate ? DateUtils.formatDate(gameDate, lang, 'short') : '';
    const partialTitle = loading ? '' : `${awayTeam}, ${homeTeam} - ${shortGameDate} | `;

    return (
        <PageHead
            title={`${partialTitle}${dictionary.game_video_highlights ?? 'Game Video Highlights'} | MLB Film Room`}
            description={
                (dictionary.game_index_page_description ?? '{{seoTitle}}. Watch all the highlights from the {{date}} {{awayTeam}} @ {{homeTeam}} game on MLB Film Room.')
                    .replace('{{seoTitle}}', data.seoTitle || data.headline)
                    .replace('{{date}}', shortGameDate)
                    .replace('{{awayTeam}}', awayTeam)
                    .replace('{{homeTeam}}', homeTeam)
            }
            structuredData={getVideoObjectSchema(mediaItem, config, lang)}
            shareImage={(data.image?.templateUrl ?? '').replace('{formatInstructions}', 'ar_16:9,g_auto,q_auto:good,w_1536,c_fill,f_jpg')}
        />
    );

};

Head.propTypes = {
    data: PropTypes.object.isRequired,
    mediaItem: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
};

export default Head;
